import { isBrowser } from './environment'

/**
 * Test if browser supports css custom properties.
 *
 * @see {@link https://justmarkup.com/log/2016/02/theme-switcher-using-css-custom-properties/}
 */
function hasCssCustomProperties(): boolean {
    if (!isBrowser()) {
        return false
    }

    return !!(window?.CSS && window.CSS?.supports && window.CSS.supports('--a', '0'))
}

export { hasCssCustomProperties }
